import React from 'react';

export const TabsContainer = ({ image, children }) => {
	return (
		<div className='image-column col-md-6 col-sm-12 col-xs-12'>
			<div className='inner clearfix'>
				<div className='out-box'>
					<div className='image-box'
					     style={{ background: `url("${require('../../../assets/images/about/office_1.jpg')}")` }} />
				</div>

				<div className='pr-content'>
					{children}
				</div>
			</div>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/Tabs/TabsContent.js